import React, { useLayoutEffect } from 'react';
import { Maskable } from 'ehs-react';
import CommunicationUtil from '../util/CommunicationUtil';

function AuthenticationWizardActivateAccountPage({
  onNextPage
}: Readonly<{
  onNextPage: () => void;
}>): React.JSX.Element {
  useLayoutEffect(() => {
    CommunicationUtil.sendActivateUserAccountRequest(() => onNextPage());
  }, [onNextPage]);
  return (
    <Maskable masked className="authentication-content-loading-spinner">
      <div className="authentication-content-loading-spinner-content" />
    </Maskable>
  );
}

export default AuthenticationWizardActivateAccountPage;
